export default __webpack_public_path__ + "static/media/screen1.bf147443.jpg";